import styled from 'styled-components'

export const CellTextWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
})
